import React, { useEffect } from 'react';

import TextSelect from 'components/layout/form/TextSelect';

import { IoIosWarning } from 'react-icons/io';
import { FaRegCalendar } from 'react-icons/fa';
import { useBases } from '../hooks/useBases';
import { REFUEL_MESSAGES } from '../constants';

import {
  Container,
  PreviewData,
  BaseWrap,
  BaseLabel,
  BaseData,
  PreviewWrap,
  TitleWrap,
  Title,
  Info,
  DescriptionWrap,
  DescriptionInfo,
  Divider,
  PreviewTitleWrap,
  TitleIconWrapper,
  IconWrapper,
  IconContainer,
} from './styles';

const PreviewRefuel: React.FC = () => {
  const {
    getBases,
    isLoading,
    bases,
    selectedBase,
    addSelectedBase,
    isUniqueBase,
    nextRefuelDate,
  } = useBases();

  useEffect(() => {
    getBases();
  }, [getBases]);

  return (
    <Container>
      {!isLoading && bases?.length > 0 && (
        <PreviewData>
          <BaseWrap>
            <BaseLabel>Local de abastecimento</BaseLabel>
            <BaseData>
              <TextSelect
                disabled={isUniqueBase}
                customHeight="38px"
                placeholder="Selecione..."
                type="text"
                value={selectedBase?.name || ''}
                onChange={(event) => {
                  addSelectedBase(event?.currentTarget?.value);
                }}
              >
                <>
                  {!selectedBase && <option value="">Selecione...</option>}
                  {bases?.length &&
                    bases.map((base) => (
                      <option key={base.name} value={base.name}>
                        {base.nickname}
                      </option>
                    ))}
                </>
              </TextSelect>
            </BaseData>
          </BaseWrap>
          <Divider />
          <PreviewWrap>
            <TitleWrap>
              <PreviewTitleWrap>
                <TitleIconWrapper>
                  <IconWrapper>
                    <FaRegCalendar size={24} color="#3D3D3D" />
                    <Title>Previsão do próximo abastecimento:</Title>
                  </IconWrapper>
                  <Info>{nextRefuelDate}</Info>
                </TitleIconWrapper>
              </PreviewTitleWrap>
            </TitleWrap>
            <DescriptionWrap>
              <IconContainer>
                <IoIosWarning size={32} color="#F8C953" />
              </IconContainer>
              <DescriptionInfo>
                {!selectedBase && <>{REFUEL_MESSAGES.SELECT_BASE}</>}
                {selectedBase && nextRefuelDate && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: REFUEL_MESSAGES.PREVIEW_DESCRIPTION,
                    }}
                  />
                )}
                {selectedBase && !nextRefuelDate && (
                  <>{REFUEL_MESSAGES.UNABLE_TO_CALCULATE}</>
                )}
              </DescriptionInfo>
            </DescriptionWrap>
          </PreviewWrap>
        </PreviewData>
      )}
    </Container>
  );
};

export default PreviewRefuel;
